import { useEffect, useState } from 'react';
import { getTextWidth } from 'common';

const ONE_REM = 0.0625;

/** Returns if the text exceeds the space available. Can be used to show a Tooltip when the complete
 * text may be truncated.
 * targetRef: the ref to the element with the text
 * text: string that is displayed
 * font: fontsize of the  text
 * padding: any extra pixels surrounding the text (in rem)
 * */
const useTooltip = (targetRef, text, font, padding = 0, listenerTarget = window) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const shouldDisplayTooltip = () => {
    if (text === undefined) {
      setShowTooltip(false);
    } else {
      // calculate text size and compare to size available to determine if a Tooltip is necessary
      const titleWidthInRem = getTextWidth(text, font) - ONE_REM; // returns rem
      const titleScrollWidth = targetRef.current ? targetRef.current.clientWidth : 0; // in pixels
      const titleScrollWidthInRem = (titleScrollWidth * ONE_REM);
      if (titleWidthInRem > titleScrollWidthInRem) {
        setShowTooltip(true);
      } else {
        setShowTooltip(false);
      }
    }
  };
  useEffect(() => {
    shouldDisplayTooltip();
    listenerTarget.addEventListener('resize', shouldDisplayTooltip);
    return () => {
      listenerTarget.removeEventListener('resize', shouldDisplayTooltip);
    };
  }, [targetRef, text, font, padding]);
  return showTooltip;
};

export default useTooltip;